import {Injectable} from '@angular/core';
import {environment} from '@environments/environment';
import CryptoJS from 'crypto-js';

@Injectable({
  providedIn: 'root',
})
export class CryptoService {
  cipherKey: string = environment.cipherKey;

  public encrypt(text: string): string {
    return CryptoJS.AES.encrypt(text, this.cipherKey).toString();
  }

  public decrypt(text: string) {
    return CryptoJS.AES.decrypt(text, this.cipherKey).toString(CryptoJS.enc.Utf8);
  }
}
